import { ajax } from "@/config/axios";
import { Post } from "@/types/post";
import { AJAX_ACTION, NONCE, OPTIONS, POST_TYPES } from "@/utils/constants";
import { useQuery, keepPreviousData } from "@tanstack/react-query";

type QueryParams = {
    post_status?: string;
    id?: number;
};

export function usePosts(postType = POST_TYPES[0].id, currentPage = 1, queryParams?: QueryParams) {
    const noPagination = currentPage === -1;

    const query = useQuery<{ posts: Post[]; total: number }>({
        queryKey: ["posts", postType, currentPage],
        queryFn: () =>
            ajax({
                action: AJAX_ACTION.GET_POSTS_BY_TYPE,
                nonce: NONCE.GET_POSTS_BY_TYPE,
                post_type: postType,
                limit: noPagination ? -1 : OPTIONS.PAGINATION_LIMIT,
                offset: noPagination ? 0 : (currentPage - 1) * OPTIONS.PAGINATION_LIMIT,
                ...queryParams,
            }),
        placeholderData: keepPreviousData,
    });

    return {
        ...query,
        isLoading: query.isLoading || (query.isFetching && query.isPlaceholderData),
    };
}
